// ============================================
// API Constants
// ============================================

export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// ── User Roles ────────────────────────────────
export const ROLES = {
    ADMIN: 'admin',
    DISPATCHER: 'dispatcher',
    DRIVER: 'driver',
    USER: 'user',
};

// ── Job Status ────────────────────────────────
export const JOB_STATUS = {
    PENDING: 'pending',
    ASSIGNED: 'assigned',
    IN_PROGRESS: 'in_progress',
    COMPLETED: 'completed',
    CANCELLED: 'cancelled',
};

// ── Driver Status ─────────────────────────────
export const DRIVER_STATUS = {
    ONLINE: 'online',
    OFFLINE: 'offline',
    ON_DUTY: 'on_duty',
    BUSY: 'busy',
};

// ── Job Types ─────────────────────────────────
export const JOB_TYPES = {
    SCHOOL_PICKUP: 'school_pickup',
    SCHOOL_DROPOFF: 'school_dropoff',
    AIRPORT: 'airport',
    PRIVATE_HIRE: 'private_hire',
    CORPORATE: 'corporate',
};

// ── Document Types ────────────────────────────
export const DOCUMENT_TYPES = {
    DRIVING_LICENCE: 'driving_licence',
    VEHICLE_INSURANCE: 'vehicle_insurance',
    MOT: 'mot',
    RIGHT_TO_WORK: 'right_to_work',
};

// ── Document Status ───────────────────────────
export const DOCUMENT_STATUS = {
    PENDING: 'pending',
    APPROVED: 'approved',
    REJECTED: 'rejected',
    EXPIRED: 'expired',
};

// ── Route Directions ──────────────────────────
export const ROUTE_DIRECTION = {
    MORNING: 'morning',    // Home → School
    AFTERNOON: 'afternoon', // School → Home
};

// ── Sidebar Nav Items by Role ─────────────────
export const ADMIN_NAV = [
    { label: 'Dashboard', path: '/admin', icon: 'LayoutDashboard' },
    { label: 'Children', path: '/admin/children', icon: 'Users' },
    { label: 'Schools & Routes', path: '/admin/schools', icon: 'MapPin' },
    { label: 'Drivers', path: '/admin/drivers', icon: 'Car' },
    { label: 'Documents', path: '/admin/documents', icon: 'FileCheck' },
    { label: 'Jobs', path: '/admin/jobs', icon: 'Briefcase' },
    { label: 'Settings', path: '/admin/settings', icon: 'Settings' },
];

export const DISPATCHER_NAV = [
    { label: 'Live Map', path: '/dispatcher', icon: 'Map' },
    { label: 'Active Jobs', path: '/dispatcher/jobs', icon: 'Activity' },
    { label: 'Drivers', path: '/dispatcher/drivers', icon: 'Car' },
];
